import UserMenu from "./UserMenu";

const Navbar = ({ onMenuClick }) => {
  return (
    <nav className="sticky top-0 z-20 bg-primary-dark backdrop-blur-sm shadow-xl">
      <div className="flex items-center justify-between px-4 sm:px-6 lg:px-10 py-2">
        <div className="flex items-center gap-3">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-lg hover:bg-white/10 transition-colors text-white"
            aria-label="Menu"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-6 h-6"
            >
              <path d="M3 12h18M3 6h18M3 18h18" />
            </svg>
          </button>
          
          <div className="hidden sm:block">
            <h1 className="text-xl lg:text-2xl font-bold text-white tracking-tight">
              Infrastructure
              <span className="text-primary-cyan">Management</span>
            </h1>
          </div>
          
          <div className="sm:hidden">
            <h1 className="text-base font-bold text-white tracking-tight">
              Infra<span className="text-primary-cyan">Mgmt</span>
            </h1>
          </div>
        </div>

        <div className="flex items-center gap-2 sm:gap-3 lg:gap-4">
          <UserMenu />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;